// Guarda de saída da tela atual (o BrowserRouter não tem useBlocker): o menu pergunta aqui antes de navegar.
// A tela registra uma função que recebe "prosseguir" e devolve true se segurou a saída (vai chamar prosseguir depois).
type Guarda = (prosseguir: () => void) => boolean

let guarda: Guarda | null = null

export function registrarGuardaSaida(g: Guarda): () => void {
  guarda = g
  return () => { if (guarda === g) guarda = null }
}

export function saidaBloqueada(prosseguir: () => void): boolean {
  return guarda ? guarda(prosseguir) : false
}
